// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1b-0";
export var spinnerContainer = "_1b-1";